import React from 'react';
const publicUrl = require('../../../util/publicUrl');

function Video(props) {
    return (
        <div className="Flooredvideo">
            <video controls poster={publicUrl("/svg/Floored.svg")} src={publicUrl("/videos/FlooredPlanVideo.mp4")} type="video/mp4" >
            </video>
        </div>
    );
}

module.exports = Video;